import React from 'react'
import st from './MergingCard.module.scss'
import ClientInformation from '../ClientInformation/ClientInformation'
import { formatClientDate } from '../utils'
import useLocalization from 'hooks/useLocalization'

const MergingCard = ({
  clickedCards,
  duplicate,
  checkedStates,
  setCheckedStates,
  selectedData,
  setSelectedData,
}) => {
  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      name: 'Name',
      level: 'Level',
      transaction: 'Transaction',
      date_of_creation: 'Date of creation',
      phone_number: 'Phone number',
      responsible: 'Responsible',
      budget: 'Budget',
      city: 'City',
      branch: 'Branch',
      program: 'Program',
      deal_status: 'Deal status',
    },
  })

  const handleCheckboxChange = (field, cardId, value) => {
    setCheckedStates((prevStates) => {
      const isSameCardSelected = prevStates[field] === cardId

      const newState = {
        ...prevStates,
        [field]: isSameCardSelected ? null : cardId,
      }

      setSelectedData((prevData) => ({
        ...prevData,
        [field]: isSameCardSelected ? '' : value,
      }))

      return newState
    })
  }

  const handleSelectAll = (cardId) => {
    setCheckedStates((prevStates) => {
      const newState = {
        ...prevStates,
        name: cardId,
        deal_name: cardId,
        created_at: cardId,
        phone: cardId,
        manager: cardId,
        budget: cardId,
        city: cardId,
        branch: cardId,
        program: cardId,
        level: cardId,
        status_deal: cardId,
      }

      setSelectedData((prevData) => ({
        ...prevData,
        name: duplicate.name,
        deal_name: clickedCards.find((card) => card.id === cardId)?.deal_name,
        created_at: clickedCards.find((card) => card.id === cardId)?.created_at,
        phone: duplicate.phone,
        manager: clickedCards.find((card) => card.id === cardId)?.manager,
        budget: clickedCards.find((card) => card.id === cardId)?.budget,
        city: clickedCards.find((card) => card.id === cardId)?.city,
        branch: clickedCards.find((card) => card.id === cardId)?.branch,
        program: clickedCards.find((card) => card.id === cardId)?.program,
        level: clickedCards.find((card) => card.id === cardId)?.level,
        status_deal: clickedCards.find((card) => card.id === cardId)
          ?.status_deal,
      }))

      return newState
    })
  }

  return (
    <div className={st.infContainer}>
      <div className={st.clientColumn}>
        {clickedCards.map((card) => (
          <div
            className={st.clientInf}
            key={card.id}
            style={{ paddingLeft: '20px' }}
          >
            <ClientInformation
              card={card}
              duplicate={duplicate}
              checkedStates={checkedStates}
              handleCheckboxChange={(field) => {
                handleCheckboxChange(
                  field,
                  card.id,
                  card[field] || duplicate[field],
                )
              }}
              handleSelectAll={() => handleSelectAll(card.id)}
            />
          </div>
        ))}
      </div>
      <div className={st.containerGreenCard}>
        <div className={st.greenCard}>
          <div className={st.containerInf}>
            <div className={st.information}>
              <div className={st.name}>{translate?.name}:</div>
              <div className={st.data}>{selectedData.name}</div>
            </div>
            <div className={st.information}>
              <div className={st.name}>{translate?.transaction}:</div>
              <div className={st.data}>#{selectedData.deal_name}</div>
            </div>
            <div className={st.invisibleInfo}></div>
            <div className={st.information}>
              <div className={st.name}>{translate?.date_of_creation}:</div>
              <div className={st.data}>
                {selectedData.created_at
                  ? formatClientDate(selectedData.created_at)
                  : ''}
              </div>
            </div>
            <div className={st.information}>
              <div className={st.name}>{translate?.phone_number}:</div>
              <div className={st.data}>{selectedData.phone}</div>
            </div>
            <div className={st.invisibleInfo}></div>
          </div>
          <div className={st.responsible}>
            <div className={st.block}>
              <div className={st.checkboxInp}>
                <div
                  className={`${st.styleRespons} ${st.widthInf}`}
                  style={{ gridArea: 'responsible' }}
                >
                  {translate?.responsible}
                </div>
                <div className={st.styleRespons}>
                  {selectedData?.manager?.full_name}
                </div>
              </div>
              <div className={st.checkboxInp}>
                <div
                  className={`${st.styleRespons} ${st.widthInf}`}
                  style={{ gridArea: 'budget' }}
                >
                  {translate?.budget}
                </div>
                <div className={st.styleRespons}>{selectedData.budget}</div>
              </div>
              <div className={st.checkboxInp}>
                <div
                  className={`${st.styleRespons} ${st.widthInf}`}
                  style={{ gridArea: 'city' }}
                >
                  {translate?.city}
                </div>
                <div className={st.styleRespons}>
                  {selectedData?.city?.name}
                </div>
              </div>
              <div className={st.checkboxInp}>
                <div
                  className={`${st.styleRespons} ${st.widthInf}`}
                  style={{ gridArea: 'branch' }}
                >
                  {translate?.branch}
                </div>
                <div className={st.styleRespons}>
                  {selectedData?.branch?.name}
                </div>
              </div>
              <div className={st.checkboxInp}>
                <div
                  className={`${st.styleRespons} ${st.widthInf}`}
                  style={{ gridArea: 'program' }}
                >
                  {translate?.program}
                </div>
                <div className={st.styleRespons}>
                  {selectedData?.program?.name}
                </div>
              </div>
              <div className={st.checkboxInp}>
                <div
                  className={`${st.styleRespons} ${st.widthInf}`}
                  style={{ gridArea: 'level' }}
                >
                  {translate?.level}
                </div>
                <div className={st.styleRespons}>
                  {selectedData?.level?.name}
                </div>
              </div>
              <div className={st.checkboxInp}>
                <div
                  className={st.styleRespons}
                  style={{ gridArea: 'status_deal' }}
                >
                  {translate?.deal_status}
                </div>
                <div className={st.styleRespons}>
                  {selectedData?.status_deal?.name}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MergingCard
